// extracted by mini-css-extract-plugin
export default {"About2Main":"About2_About2Main__Zv5h6","About2Parent":"About2_About2Parent__CcS-B","About2Child":"About2_About2Child__UxD6J","AboutBro":"About2_AboutBro__ZZpMw"};